<form [formGroup]="courierForm" (keydown.enter)="$event.preventDefault()">
  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mb--10 fdx-u-mt--10">
    <div class="fdx-o-grid__item--11 fdx-o-grid__item--12@medium">
      <div class="fdx-o-grid__row fdx-o-grid__row--guttered-small">
        <app-form-input-control
          class="fdx-o-grid__item--12"
          [formField]="name"
          [labelName]="'Nazwa kontaktu *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="name"
            formControlName="name"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--12"
          [formField]="company"
          [labelName]="'Firma'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="company"
            formControlName="company"
            [maxLength]="150" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="zipCode"
          [labelName]="'Kod pocztowy *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="zip_code"
            formControlName="zip_code"
            pattern="^[0-9]{2}-[0-9]{3}$"
            maxlength="6"
            (input)="this.formService.formatZipCode($event)" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="city"
          [labelName]="'Miejscowość *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="city"
            formControlName="city"
            [maxLength]="85" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="street"
          [labelName]="'Ulica *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="street"
            formControlName="street"
            [maxLength]="70" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--3"
          [formField]="houseNumber"
          [labelName]="'Nr Domu *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="house_number"
            formControlName="house_number" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--3"
          [formField]="apartmentNumber"
          [labelName]="'Nr lokalu'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="apartment_number"
            formControlName="apartment_number" />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="phone"
          [labelName]="'Telefon kontaktowy *'">
          <input
            type="text"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="phone"
            formControlName="phone"
            (input)="
              this.formService.onInputForNumberField2(
                $event,
                courierForm.get('phone')
              )
            " />
        </app-form-input-control>

        <app-form-input-control
          class="fdx-o-grid__item--6"
          [formField]="email"
          [labelName]="'Adres e-mail *'">
          <input
            type="email"
            class="fdx-c-form-group__input fdx-u-px--4"
            id="email"
            formControlName="email" />
        </app-form-input-control>
      </div>
    </div>
  </div>

  <app-form-error-message
    [submitException]="submitException()"
    [form]="courierForm">
  </app-form-error-message>

  <div
    class="fdx-o-grid__row fdx-o-grid__row--center fdx-o-grid__row--guttered-small fdx-u-mb--5">
    <app-back-button
      [isLoading]="false"
      [isDisabled]="isSubmitLoading()"
      [buttonText]="'WSTECZ'"
      (clickEvent)="backButtonAction()">
    </app-back-button>
    <app-submit-button
      [isLoading]="isSubmitLoading()"
      [isDisabled]="courierForm.invalid"
      [buttonText]="'DALEJ'"
      (clickEvent)="onSubmit()"
      style="margin-left: 5px; margin-right: 2.5px">
    </app-submit-button>
  </div>
</form>
